/**
 * Update date: 15-05-2023
 * Screen 1044.3
 */
import useAxios from 'axios-hooks';
import LoadPanel from 'app/components/LoadPanel';
import ArrayStore from 'devextreme/data/array_store';
import React, { createContext, useContext, useState } from 'react';
import FormSearch from './FormSearch';
import ListReportVendor from './ListReportVendor';

  /**
   * create context
   */
const ReportVendorContext = createContext({});

ReportVendorContext.displayName = 'ReportVendorContext';

export const useReportVendor = () => {
  const context = useContext(ReportVendorContext);
  return context;
};

export default function ReportVendor() {
  // Get data vendor
  const [{ data, loading }, refetchData] = useAxios(
    {
      url: '/user/vendor/report',
      method: 'POST',
    },
    { manual: true, autoCancel: true },
  );
  const store: any = new ArrayStore({
    data: data?.data,
    key: 'vendorId',
  });

  const value: any = {
    store,
    refetchData,
  };

  return (
    <ReportVendorContext.Provider value={value}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loading} />
        <FormSearch />
        <ListReportVendor />
      </React.Suspense>
    </ReportVendorContext.Provider>
  );
}
